module.exports = __webpack_public_path__ + "static/media/sa.af3e5959.png";